var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparklesTwo = function SvgSparklesTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M14.667 10C11.426 10 10 11.428 10 14.668c0-3.24-1.426-4.666-4.667-4.666C8.574 10 10 8.575 10 5.334c0 3.24 1.426 4.667 4.667 4.667ZM7.333 4.334c-2.083 0-3 .917-3 3 0-2.083-.916-3-3-3 2.084 0 3-.917 3-3 0 2.083.917 3 3 3Z",
    clipRule: "evenodd"
  })));
};
export default SvgSparklesTwo;